<div class="modal-header">
  <h3 class="modal-title">Preis aus Preisliste</h3>
</div>

<form (ngSubmit)="submit()">
  <div class="modal-body">

    <div class="pricecheck-modal-row">
      <div class="pricecheck-modal-empty">
        <h3>Preisliste</h3>
      </div>
    </div>


    @if (data.price.releases && data.price_type ==='de') {
      <div class="pricecheck-modal-row">
        <div class="pricecheck-modal-empty">
          <span class="bold col-sm-12 headline"><img src="/ui/assets/images/flags/de.png" title="DE"> Deutschland</span>
          <table class="table whitetable">
            <thead>
              <tr>
                <th>K-ME</th>
                <th>Lose</th>
                <th>Freigabe</th>
                <th>Einzel €</th>
                <th>Kalk</th>
                <th>Datum</th>
                <th>Notiz</th>
              </tr>
            </thead>
            <tbody>
              @for (release of data.price.releases; track release) {
                <tr
                  [ngClass]="{'selected': isSelected($safeNavigationMigration(release?.release))}"
                  (click)="select(release.release)"
                  class="selectable-row">
                  @if (release.calc_quanity) {
                    <td> {{ release.calc_quanity }} </td>
                  }
                  @if (!release.calc_quanity) {
                    <td>{{release.quanity}}</td>
                  }
                  <td> {{ release.lose }} </td>
                  <td> {{ release.release }} </td>
                  <td> <strong>{{ release.single }}</strong> </td>
                  <td> <strong>{{ release.calc }}</strong> </td>
                  <td> {{ release.date|date: "dd.MM.yyyy" }} </td>
                  <td class="notes-truncated-modal" title="{{release.notes}}">
                    @if (release.notes) {
                      <span class="notes-inner">
                        {{ release.notes }}
                      </span>
                      } &nbsp;
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      @if (data.price.releases && data.price_type ==='cn') {
        <div class="pricecheck-modal-row">
          <div class="pricecheck-modal-empty">
            <span class="bold col-sm-12 headline"><img src="/ui/assets/images/flags/cn.png" title="DE"> China</span>
            <table class="table whitetable">
              <thead>
                <tr>
                  <th>K-ME</th>
                  <th>Lose</th>
                  <th>Freigabe</th>
                  <th>Produzent</th>
                  <th>Einzel €</th>
                  <th>Kalk</th>
                  <th>Datum</th>
                  <th>Notiz</th>
                </tr>
              </thead>
              <tbody>
                @for (release of data.price.releases; track release) {
                  <tr
                    [ngClass]="{'selected': isSelected($safeNavigationMigration(release?.release))}"
                    (click)="select(release.release)"
                    class="selectable-row">
                    @if (release.calc_quanity) {
                      <td> {{ release.calc_quanity }} </td>
                    }
                    @if (!release.calc_quanity) {
                      <td>{{release.quanity}}</td>
                    }
                    <td> {{ release.lose }} </td>
                    <td> {{ release.release }} </td>
                    @if (release.producer) {
                      <td> {{release.producer }}</td>
                    }
                    @if (!release.producer) {
                      <td></td>
                    }
                    <td> <strong>{{ release.single }}</strong> </td>
                    <td> <strong>{{ release.calc }}</strong> </td>
                    <td> {{ release.date|date: "dd.MM.yyyy" }} </td>
                    <td class="notes-truncated-modal" title="{{release.notes}}">
                      @if (release.notes) {
                        <span class="notes-inner">
                          {{ release.notes }}
                        </span>
                        } &nbsp;
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }


      </div>

      <div class="modal-footer">
        <button type="button" (click)="dismiss()" class="btn btn-default pull-left">Abbrechen</button>

        <button class="btn btn-success pull-right" type="submit">
          Übernehmen
        </button>
      </div>
    </form>
